var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.77 5.277l-3.54 3.538a3.503 3.503 0 001.86 5.926l-1.21 1.21a4.988 4.988 0 01-1.71-1.12 4.988 4.988 0 01-1.466-3.539 4.994 4.994 0 011.465-3.538l3.539-3.538a5.004 5.004 0 017.076 7.076l-2.014 2.015a6.537 6.537 0 00-.124-2l1.077-1.076a3.503 3.503 0 00-4.954-4.954z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.77 15.184l-3.54 3.539a3.503 3.503 0 01-4.953-4.954l1.077-1.077a6.54 6.54 0 01-.124-1.999l-2.014 2.015a5.004 5.004 0 007.076 7.076l3.539-3.538a4.996 4.996 0 001.465-3.588 4.988 4.988 0 00-1.465-3.489 4.987 4.987 0 00-1.71-1.12l-1.211 1.21a3.503 3.503 0 011.86 5.925z",
    fill: "currentColor"
  })));
}
export default SvgLink;